import { Header } from "./common/Header";
import { Link } from "react-router-dom";
import { Icons } from "./utils/Icons";
import { Footer } from "./common/Footer";
import arrowBackIcon from "./assets/img/arrowBack.svg";

export default function AunTienesDudas() {
  return (
    <div className="appContainer" style={{ backgroundColor: "#FFF" }}>
      <div className="mainHeader">
        <Header />
      </div>
      <main className="legalDocument mainWidth">
        <Link to="/" className="smallButton">
          <Icons path={arrowBackIcon} />
          Volver
        </Link>
        <div className="container">
          <h1>¿Aún tienes dudas? Contáctanos</h1>
          <ol>
            <ol>
              <li>
                <p>
                  En nuestro Centro de Ayuda, encontrarás una amplia variedad de artículos diseñados para resolver las dudas más comunes sobre el uso de Mega GO, suscripciones, pagos, dispositivos compatibles y mucho más. Sin embargo, entendemos que hay ocasiones en las que podrías necesitar una atención más personalizada.
                  Si revisaste nuestros artículos y aún no encontraste la respuesta que buscabas, no te preocupes. Puedes escribirnos directamente a nuestro correo oficial <strong>contacto@megago.cl</strong> y nuestro equipo de soporte te ayudará lo antes posible.
                  Recuerda adjuntar los datos necesarios para agilizar la atención y mencionarnos el correo vinculado a tu suscripción actual.
                </p>
              </li>
            </ol>
          </ol>
        </div>
      </main>
      <Footer />
    </div>
  );
}
